module.exports = __webpack_public_path__ + "static/img/Grand-Palais.b9ea7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Grand-Palais.jpg
// module id = ydYL
// module chunks = 0